import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscountIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.75 28.75H28C29.5188 28.75 30.75 27.5188 30.75 26V21.75H23.2113H23.202H21.8107L23.5303 23.4697C23.8232 23.7626 23.8232 24.2374 23.5303 24.5303C23.2374 24.8232 22.7626 24.8232 22.4697 24.5303L20.75 22.8107V28.75Z",
			fill: "#80A532"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.1893 21.75L16.4697 23.4697C16.1768 23.7626 16.1768 24.2374 16.4697 24.5303C16.7626 24.8232 17.2374 24.8232 17.5303 24.5303L19.25 22.8107V28.75H12C10.4812 28.75 9.25 27.5188 9.25 26V21.75H16.7887H16.798H18.1893Z",
			fill: "#80A532"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.75 14V20.25H26.0065C26.5495 19.4069 26.75 18.3523 26.75 17.3988C26.75 16.1134 25.6339 15.0507 24.3205 15.2806C22.8208 15.5432 21.587 16.6674 20.75 17.7577V11.25H28C29.5188 11.25 30.75 12.4812 30.75 14Z",
			fill: "#80A532"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7906 20.25H19.0114C19.0006 20.2256 18.9893 20.2006 18.9776 20.1751C18.7798 19.7448 18.4872 19.2404 18.1198 18.7497C17.3624 17.7382 16.3985 16.9293 15.4209 16.7581C15.1113 16.704 14.75 16.9559 14.75 17.3988C14.75 18.177 14.9191 18.9197 15.2575 19.4423C15.57 19.9251 16.0379 20.2479 16.7906 20.25Z",
			fill: "#80A532"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0223 20.1751C21.0106 20.2006 20.9993 20.2256 20.9885 20.25H23.2093C23.962 20.2479 24.4299 19.9251 24.7424 19.4423C25.0808 18.9197 25.2499 18.177 25.2499 17.3988C25.2499 16.9559 24.8886 16.704 24.579 16.7581C23.6014 16.9293 22.6375 17.7382 21.8801 18.7497C21.5127 19.2404 21.2201 19.7448 21.0223 20.1751Z",
			fill: "#80A532"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.25 20.25H13.9935C13.4505 19.4069 13.25 18.3523 13.25 17.3988C13.25 16.1134 14.3661 15.0507 15.6795 15.2806C17.1792 15.5432 18.413 16.6674 19.25 17.7577V11.25H12C10.4812 11.25 9.25 12.4812 9.25 14V20.25Z",
			fill: "#80A532"
		})
	]
});
export default SvgDiscountIcon;
